import { createSelector } from 'reselect'

export const getSearchShowModalScreen = createSelector([(state) => state.searchModalScreenStore.searchShow], (data) => data)
